import { Modal, Button, Tag, MenuProps, Dropdown, Pagination, Popconfirm } from 'antd';
import React, { useEffect, useState } from "react";
import CreateAccountModalContent, { AccountUserData } from './CreateUserModal';
import { DotsThreeOutlineIcon, EyeIcon, PencilSimpleLineIcon } from '@phosphor-icons/react';
import UserEditContent from './UserEditModalContent';
import UserDetailModalContent from './UserDetailModalContent';
import EditUserAssignAccountModalContent from './EditUserAssignAccount';
import { useTheme } from 'components/provider/theme';
import { API_URL } from 'env';
import { toast } from 'react-toastify';

export type User = {
    id: string;
    name: string;
    email: string;
    phonenumber?: string;
    status: string;
    balance: number;
    lastLogin: string;
    firstName: string;
    lastName: string;
    jobTitle?: string;
    country?: string;
    city?: string;
    address?: string;
    postalCode?: string;
    dateOfBirth?: string;
    gender?: string;
    isActive?: boolean;
    avatar_url?: string;
    roles?: any[];
    createAt?: string;
    updateAt?: string;
    accountType?: "std" | 'vip' | 'pre'; // Optional field for account type
    KYC?: boolean; // Optional field for KYC status
};

type UserAccountListItemProps = {
    user: User;
    trigger?: () => void; // Optional trigger function for updates
};


const UserAccountList = () => {

    const [userList, setUserList] = useState<User[]>();
    const [filterUserList, setFilterUserList] = useState<User[]>([]);
    const [searchQuery, setSearchQuery] = useState<string>("");
    const [selectFillter, setSelectFilter] = useState<string>("all");
    const [page, setPage] = useState<number>(1);
    const [totalPage, setTotalPage] = useState<number>(0);
    const [resetCounter, setResetCounter] = useState<number>(0);
    const { theme } = useTheme()
    function resetData() {
        setResetCounter(resetCounter + 1);
        setSearchQuery("");
        setSelectFilter("all");
        setPage(1);
        setFilterUserList(userList || []);
    }
    const handleFilterChange = (e: React.ChangeEvent<HTMLSelectElement>) => {
        const value = e.target.value;
        setSelectFilter(value);
    };
    async function fetchData(page = 1 , limit = 10) {

        const data = await fetch(`${API_URL}api/v1/be/users?page=${page}&limit=${limit}`, {
            method: 'GET',
            headers: {
                'Content-Type': 'application/json',
                'Authorization': `Bearer ${localStorage.getItem('token')}`
            }
        })
        const result = await data.json();
        if (result.status) {
            const users = result.data.items.map((user: any) => ({
                id: user.id,
                name: user.full_name_display || user.fullname || user.email || "No Name",
                email: user.email,
                phonenumber: user.phone || "",
                status: user.is_active === 1 ? "Active" : "Inactive",
                balance: 0,
                lastLogin: "",
                firstName: user.first_name || "",
                lastName: user.last_name || "",
                jobTitle: user.job_title || "",
                country: user.country || "",
                city: user.city || "",
                address: user.address || "",
                postalCode: user.postal_code || "",
                avatar_url: user.avatar_url || ""
            }));
            setUserList(users);
            setTotalPage(result.data.total);
            setPage(result.data.current_page);
        }
    }
    useEffect(() => {
        fetchData();
    }, []);


    return (
        <div className="flex flex-col h-full">

            <div className={`${theme === 'dark' ? 'bg-gray-800' : 'bg-white border border-gray-200'} rounded-xl shadow-sm  p-6 mb-6`}>
                <div className="flex flex-col w-full md:flex-row md:justify-between space-y-4 md:space-y-0">
                    <div className="flex items-center w-full md:flex-row md:justify-between space-x-4">
                        <div className="relative">
                            <svg xmlns="http://www.w3.org/2000/svg" width="24" height="24" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round" className="lucide lucide-search absolute left-3 top-1/2 transform -translate-y-1/2 text-gray-400 h-5 w-5">
                                <circle cx="11" cy="11" r="8"></circle>
                                <path d="m21 21-4.3-4.3"></path>
                            </svg>
                            <input
                                value={searchQuery}
                                onChange={(e) => setSearchQuery(e.target.value)}
                                type="text"
                                placeholder="Tìm kiếm người dùng"
                                className={`pl-10 pr-4 py-2 ${theme === 'dark' ? 'placeholder:text-white !text-white' : 'text-black placeholder:text-gray-500 focus:ring-2 focus:ring-blue-500 focus:border-blue-500'} border border-gray-300 rounded-lg  w-64`}
                            />
                        </div>
                        <div className="inline-flex items-center space-x-4">
                            <div className="flex items-center space-x-2">
                                <svg xmlns="http://www.w3.org/2000/svg" width="24" height="24" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round" className="lucide lucide-filter h-5 w-5 text-gray-400">
                                    <polygon points="22 3 2 3 10 12.46 10 19 14 21 14 12.46 22 3"></polygon>
                                </svg>
                                <select
                                    value={selectFillter}
                                    onChange={handleFilterChange}
                                    title="Lọc theo trạng thái"
                                    className={`${theme === 'dark' ? '!text-white bg-gray-800' : ''} border border-gray-300 rounded-lg px-3 py-2 focus:ring-2 focus:ring-blue-500 focus:border-blue-500`}>
                                    <option value="all">Tất cả trạng thái</option>
                                    <option value="active">Hoạt động</option>
                                    <option value="inactive">Không hoạt động</option>
                                    <option value="suspended">Tạm khóa</option>
                                </select>
                            </div>
                        </div>
                    </div>
                </div>
            </div>

            <div className={`${theme === 'dark' ? 'bg-gray-800' : 'bg-white border border-gray-200'} rounded-xl shadow-sm w-full overflow-x-scroll`}
            style={{ scrollbarWidth: 'none', WebkitOverflowScrolling: 'touch' }}
            >
                <table className={` ${theme === 'dark' ? 'bg-gray-800' : 'bg-white border border-gray-200'} w-full `}>
                    <thead className={`${theme === 'dark' ? 'bg-gray-800 border-b border-gray-700' : 'bg-white border border-gray-50'} `}>
                        <tr>
                            <th className={` ${theme === 'dark' ? 'text-white' : 'text-gray-500'} px-6 py-4 text-left text-xs font-medium uppercase tracking-wider`}>
                                Người dùng
                            </th>
                            <th className={` ${theme === 'dark' ? 'text-white' : 'text-gray-500'} px-6 py-4 text-left text-xs font-medium uppercase tracking-wider`}>
                                Liên hệ
                            </th>
                            <th className={` ${theme === 'dark' ? 'text-white' : 'text-gray-500'} 2xl:table-cell hidden px-6 py-4 text-left text-xs font-medium uppercase tracking-wider`}>
                                Loại tài khoản
                            </th>
                            <th className={` ${theme === 'dark' ? 'text-white' : 'text-gray-500'} 2xl:table-cell hidden px-6 py-4 text-left text-xs font-medium uppercase tracking-wider`}>
                                Trạng thái
                            </th>
                            <th className={` ${theme === 'dark' ? 'text-white' : 'text-gray-500'} xl:table-cell hidden px-6 py-4 text-left text-xs font-medium uppercase tracking-wider`}>
                                Số dư
                            </th>
                            <th className={` ${theme === 'dark' ? 'text-white' : 'text-gray-500'} px-6 py-4 text-left text-xs font-medium uppercase tracking-wider`}>
                                Đăng nhập cuối
                            </th>
                            <th className={` ${theme === 'dark' ? 'text-white' : 'text-gray-500'} px-6 py-4 text-left text-xs font-medium uppercase tracking-wider`}>
                                Thao tác
                            </th>
                        </tr>
                    </thead>
                    <tbody>
                        {
                            (userList ?? []).map((user, index) => (
                                <UserAccountListItem key={index} user={user} trigger={() => fetchData()} />
                            ))
                        }
                    </tbody>
                </table>
                <Pagination
                    current={page}
                    total={totalPage}
                    align='end'
                    pageSize={10}
                    onChange={(page, pageSize) => {
                        fetchData(page, pageSize);
                    }}
                    showSizeChanger={false}
                    showTotal={(total) => `Tổng ${total} người dùng`}
                />
            </div>
        </div>
    );
}


const UserAccountListItem = ({ user, trigger }: UserAccountListItemProps) => {
    // Edit
    const [openEditModal, setOpenEditModal] = useState(false);
    const [confirmLoading, setConfirmLoading] = useState(false);
    const handleEditOk = () => {
        setConfirmLoading(true);

    };
    const handleEditCancel = () => {
        setOpenEditModal(false);
    };

    // Delete User 
    async function deleteUser(userId: string) {
        try {
            const response = await fetch(`${API_URL}api/v1/be/user/${userId}`, {
                method: 'DELETE',
                headers: {
                    'Content-Type': 'application/json',
                    'Authorization': `Bearer ${localStorage.getItem('token')}`
                }
            });
            if (response.ok) {
                toast.success('User deleted successfully');
                // Optionally, you can trigger a refresh of the user list
                trigger && trigger();
            } else {
                toast.error('Failed to delete user , This function is disabled in demo');
            }
        } catch (error) {
            console.error('Error deleting user:', error);
        }
    }


    // Detail 
    const [openDetailModal, setOpenDetailModal] = useState(false);
    const handleDetailOk = () => {
        setOpenDetailModal(true);
    };
    const handleDetailCancel = () => {
        console.log('Clicked cancel button');
        setOpenDetailModal(false);
    };

    // Edit User Assign Account
    const [openAssignAccountModal, setOpenAssignAccountModal] = useState(false);
    const handleAssignAccountOk = () => {
        setOpenAssignAccountModal(true);
    };
    const handleAssignAccountCancel = () => {
        setOpenAssignAccountModal(false);
    };
    const { theme } = useTheme()

    // More options
    const items: MenuProps['items'] = [
        {
            label: (
                <p className='!m-0'>
                    View Profile - {user.name}
                </p>
            ),
            key: '0',
            onClick: () => {
                window.location.href = `/users/${user.id}`;
            }
        },
        {
            label: (
                <p className='!m-0'>
                    Edit role
                </p>
            ),
            onClick: () => {
                window.location.href = `/role`;
            },
            key: '1',
        },
        {
            type: 'divider',
        },
        {
            label: (
                <p className='!m-0'>
                    View Assigned Accounts
                </p>
            ),
            key: '3',
            onClick: () => {
                setOpenAssignAccountModal(true);
            }
        },
        {
            label: (
                <Popconfirm
                    title="Delete the user"
                    description="Are you sure to delete ?"
                    onConfirm={() => deleteUser(user.id)}
                    onCancel={() => console.log('Cancel')}
                    okText="Yes"
                    className='cursor-pointer transition-colors duration-200'
                    cancelText="No"
                >
                    <p className='!m-0'>
                        Delete User
                    </p>
                </Popconfirm>
            ),
            key: '4',
            danger: true,

        },
    ];


    return (
        <tr className={`${theme === 'dark' ? 'border-b border-gray-700 hover:bg-gray-700' : 'hover:bg-gray-50'} transition-colors`}>
            <td className="px-6 py-2">
                <div className="flex items-center space-x-3">
                    {
                        user.avatar_url ? (
                            <img src={user.avatar_url} alt={user.name} className="w-10 h-10 rounded-full" />
                        ) : (
                            <div className="flex-shrink-0 h-10 w-10 bg-gradient-to-br from-blue-500 to-purple-600 rounded-full flex items-center justify-center">
                                <span className="text-white font-medium text-sm">
                                    {
                                        user.firstName && user.lastName
                                            ? `${user.firstName.charAt(0)}${user.lastName.charAt(0)}`
                                            : user.name ? user.name.charAt(0) : "U"
                                    }
                                </span>
                            </div>
                        )
                    }
                    <div className="flex flex-col justify-center">
                        <div className="flex items-center space-x-2">
                            <p className={`text-sm font-medium ${theme === 'dark' ? 'text-white' : 'text-gray-900'} !mb-0`}>{user.name}</p>
                            {
                                user.KYC ? (
                                    <svg xmlns="http://www.w3.org/2000/svg" width="24" height="24" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round" className="lucide lucide-user-check h-4 w-4 text-green-500"><path d="M16 21v-2a4 4 0 0 0-4-4H6a4 4 0 0 0-4 4v2"></path><circle cx="9" cy="7" r="4"></circle><polyline points="16 11 18 13 22 9"></polyline></svg>
                                ):
                                (
                                    <svg xmlns="http://www.w3.org/2000/svg" width="24" height="24" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round" className="lucide lucide-user-x h-4 w-4 text-red-500"><path d="M16 21v-2a4 4 0 0 0-4-4H6a4 4 0 0 0-4 4v2"></path><circle cx="9" cy="7" r="4"></circle><line x1="18" y1="8" x2="22" y2="12"></line><line x1="22" y1="8" x2="18" y2="12"></line></svg>
                                )
                            }
                        </div>
                        <p className={`text-sm ${theme === 'dark' ? 'text-blue-600' : 'text-gray-500'}  !m-0`}>ID: {user.id}</p>
                    </div>
                </div>
            </td>
            <td className="px-6 py-2">
                <div className="space-y-1">
                    <div className="flex items-center space-x-2">
                        <svg xmlns="http://www.w3.org/2000/svg" width="24" height="24" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round" className="lucide lucide-mail h-4 w-4 text-gray-400"><rect width="20" height="16" x="2" y="4" rx="2"></rect><path d="m22 7-8.97 5.7a1.94 1.94 0 0 1-2.06 0L2 7"></path></svg>
                        <span className={`text-sm font-medium ${theme === 'dark' ? 'text-white' : 'text-gray-900'} !mb-0`}>{user.email}</span>
                    </div>
                    <div className="flex items-center space-x-2">
                        <svg xmlns="http://www.w3.org/2000/svg" width="24" height="24" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round" className="lucide lucide-phone h-4 w-4 text-gray-400"><path d="M22 16.92v3a2 2 0 0 1-2.18 2 19.79 19.79 0 0 1-8.63-3.07 19.5 19.5 0 0 1-6-6 19.79 19.79 0 0 1-3.07-8.67A2 2 0 0 1 4.11 2h3a2 2 0 0 1 2 1.72 12.84 12.84 0 0 0 .7 2.81 2 2 0 0 1-.45 2.11L8.09 9.91a16 16 0 0 0 6 6l1.27-1.27a2 2 0 0 1 2.11-.45 12.84 12.84 0 0 0 2.81.7A2 2 0 0 1 22 16.92z"></path></svg>
                        <span className="text-sm text-gray-500 !m-0">{user.phonenumber || 'Not set'}</span>
                    </div>
                </div>
            </td>
            <td className="px-6 py-2 2xl:table-cell hidden">
                <div className="flex items-center space-x-2">
                    <Tag color={user.accountType === "vip" ? "gold" : user.accountType === "pre" ? "blue" : "green"}>
                        {user.accountType === "vip" ? "VIP" : user.accountType === "pre" ? "PREMIUM" : "STANDARD"}
                    </Tag>
                </div>
            </td>
            <td className="px-6 py-2 2xl:table-cell hidden">
                <span className={`px-3 py-1 rounded-full text-xs font-medium border ${user.status === "Active"
                    ? "bg-green-100 text-green-800 border-green-200"
                    : "bg-gray-100 text-gray-800 border-gray-200"
                    }`}>
                    {user.status}
                </span>
            </td>
            <td className="px-6 py-2 xl:table-cell hidden">
                <p className={`text-sm font-medium ${theme === 'dark' ? 'text-white' : 'text-gray-900'} !mb-0`}>
                    ${user.balance.toLocaleString()}
                </p>
            </td>
            <td className="px-6 py-2">
                <p className="text-sm text-gray-500">{user.lastLogin}</p>
            </td>
            <td className="px-6 py-2">
                <div className="flex items-center space-x-3">
                    <Modal
                        title="User Details"
                        open={openDetailModal}
                        onOk={handleDetailOk}
                        confirmLoading={confirmLoading}
                        onCancel={handleDetailCancel}
                        height={500}
                        width={800}
                        style={{ top: 20 }}
                        footer={null}
                    >
                        <UserDetailModalContent user={user} onClose={() => setOpenDetailModal(false)} />
                    </Modal>
                    <div
                        onClick={() => setOpenDetailModal(true)}
                        className={`${theme === 'dark' ? 'text-black' : ''}  cursor-pointer hover:text-blue-500 flex items-center space-x-1 p-2 rounded-[4px] bg-gray-100 transition-colors duration-300`}>
                        <EyeIcon
                            size={20} className='' />
                    </div>
                    <Modal
                        title="Edit User Account"
                        open={openEditModal}
                        onOk={handleEditOk}
                        confirmLoading={confirmLoading}
                        onCancel={handleEditCancel}
                        footer={null}
                    >
                        <UserEditContent
                            user={user}
                            onCancel={() => setOpenEditModal(false)}
                            triggerUpdate={() => {
                                trigger && trigger();
                            }}
                        />
                    </Modal>
                    <div
                        onClick={() => setOpenEditModal(true)}
                        className={`${theme === 'dark' ? 'text-black' : ''} cursor-pointer hover:text-blue-500 flex items-center space-x-1 p-2 rounded-[4px] bg-gray-100 transition-colors duration-300`}>
                        <PencilSimpleLineIcon
                            size={20} />
                    </div>
                    <Modal
                        title="Edit User Assign Account"
                        open={openAssignAccountModal}
                        onOk={handleAssignAccountOk}
                        footer={null}
                        onCancel={handleAssignAccountCancel}
                        width={1000}
                    >
                        <EditUserAssignAccountModalContent userId={user.id} />
                    </Modal>

                    <Dropdown menu={{ items }} trigger={['click']}>
                        <div className={`${theme === 'dark' ? 'text-black' : ''} cursor-pointer hover:text-blue-500 transition-colors flex items-center space-x-1 p-2 rounded-[4px] bg-gray-100 duration-300`}>
                            <DotsThreeOutlineIcon
                                size={20} weight="fill" />
                        </div>
                    </Dropdown>

                </div>
            </td>
        </tr>
    );
}
export default UserAccountList;